export const assetIcons = {
    image: 'image',
    file: 'description',
};
